var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93044 7.00258C2.9602 9.91639 5.73946 12.0026 9.00392 12.0026C12.2684 12.0026 15.0476 9.91642 16.0774 7.00263C15.0476 4.08882 12.2684 2.0026 9.00391 2.0026C5.73946 2.0026 2.96021 4.08879 1.93044 7.00258ZM0.257043 6.75286C1.42489 3.03462 4.89815 0.335938 9.00391 0.335938C13.1097 0.335938 16.583 3.03466 17.7508 6.75293C17.8018 6.91549 17.8018 7.08979 17.7508 7.25235C16.5829 10.9706 13.1097 13.6693 9.00392 13.6693C4.89815 13.6693 1.42487 10.9706 0.257041 7.25228C0.205986 7.08972 0.205986 6.91542 0.257043 6.75286ZM9.00354 5.33594C8.08307 5.33594 7.33687 6.08213 7.33687 7.0026C7.33687 7.92308 8.08307 8.66927 9.00354 8.66927C9.92401 8.66927 10.6702 7.92308 10.6702 7.0026C10.6702 6.08213 9.92401 5.33594 9.00354 5.33594ZM5.67021 7.0026C5.67021 5.16165 7.16259 3.66927 9.00354 3.66927C10.8445 3.66927 12.3369 5.16165 12.3369 7.0026C12.3369 8.84355 10.8445 10.3359 9.00354 10.3359C7.16259 10.3359 5.67021 8.84355 5.67021 7.0026Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.890fa37a5f65337712d1552c670122da.svg";
export { ForwardRef as ReactComponent };